/**
 * /dashboard — Surface Layer (/01)
 *
 * The single protected authenticated landing. It renders plane-specific
 * content: operators (DevHub plane) get the operator overview; members
 * (UserHub plane) get the Workspace overview. The same route, different
 * components — never a generic shared dashboard, never a cross-hub leak.
 *
 * Access is enforced by the root guard (identity + non-fragile + setup gate);
 * the plane is resolved from the identity's roles (see useResolvedPlane).
 */

import { createFileRoute } from '@tanstack/react-router';
import { useResolvedPlane } from '@lib/navigation/useActivePlane';
import { DevHubDashboard } from '../components/dashboard/DevHubDashboard';
import { UserHubDashboard } from '../components/dashboard/UserHubDashboard';

export const Route = createFileRoute('/dashboard')({
  component: DashboardRoute,
});

function DashboardRoute() {
  const plane = useResolvedPlane();
  return plane === 'devhub' ? <DevHubDashboard /> : <UserHubDashboard />;
}
